import { render, staticRenderFns } from "./IconMonitor.vue?vue&type=template&id=131feb5a&scoped=true&"
import script from "./IconMonitor.vue?vue&type=script&lang=js&"
export * from "./IconMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131feb5a",
  null
  
)

export default component.exports